var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconUnpairing = function SvgIconUnpairing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.458 3.884a.5.5 0 0 1 0 .707L4.247 20.784a.5.5 0 0 1-.707-.707l16.21-16.193a.5.5 0 0 1 .706 0M16.331 5.886a6.47 6.47 0 0 0-4.331.97 6.5 6.5 0 0 0-7.359 10.71l.717-.717a5.5 5.5 0 0 1 5.785-9.34 6.48 6.48 0 0 0-2.091 5.65l.95-.949A5.49 5.49 0 0 1 12 8.09c.387.32.73.693 1.018 1.106l.717-.716a6.5 6.5 0 0 0-.879-.97 5.5 5.5 0 0 1 2.526-.675zm-1.383 5.623q.051.405.052.825a6.48 6.48 0 0 1-2.144 4.824 5.5 5.5 0 0 0 5.785-9.34l.718-.715A6.5 6.5 0 0 1 12 17.813a6.47 6.47 0 0 1-4.331.968l.95-.948a5.5 5.5 0 0 0 2.525-.675 6.5 6.5 0 0 1-.88-.97l.718-.717c.288.413.63.786 1.018 1.106a5.49 5.49 0 0 0 1.999-4.12z",
    clipRule: "evenodd"
  })));
};
export default SvgIconUnpairing;